import AboutCompany from './about-company';

export default AboutCompany;